<template>
  <v-app>

    <v-navigation-drawer v-model="drawer" temporary app>
      <v-list class="logo-drawer d-flex justify-center">
        <!-- Ajustar tamaño máximo del logo en el drawer -->
        <v-img 
          src="@/assets/aml_logo.png"
          contain
          max-height="64"
          max-width="64"
          ></v-img>
      </v-list>

      <v-divider></v-divider>

      <v-list>

        <v-list-item :to="{ path: '/' }" class="drawer-list-item">
          <v-list-item-icon>
            <v-icon>mdi-home</v-icon>
          </v-list-item-icon>
          <v-list-item-content>
            <v-list-item-title>Principal</v-list-item-title>
          </v-list-item-content>
        </v-list-item>

        <v-list-item :to="{ path: '/recetas' }" class="drawer-list-item">
          <v-list-item-icon>
            <v-icon>mdi-pencil </v-icon>
          </v-list-item-icon>
          <v-list-item-content>
            <v-list-item-title>Recetas</v-list-item-title>
          </v-list-item-content>
        </v-list-item>

        <v-list-item :to="{ path: '/datalogger' }" class="drawer-list-item">
          <v-list-item-icon>
            <v-icon>mdi-account-details</v-icon>
          </v-list-item-icon>
          <v-list-item-content>
            <v-list-item-title>Datalogger</v-list-item-title>
          </v-list-item-content>
        </v-list-item>
        
        <v-list-item :to="{ path: '/alarmas' }" class="drawer-list-item">
          <v-list-item-icon>
            <v-icon>mdi-alert</v-icon>
          </v-list-item-icon>
          <v-list-item-content>
            <v-list-item-title>Alarmas</v-list-item-title>
          </v-list-item-content>
        </v-list-item>
        
        <v-list-item :to="{ path: '/ajustes' }" class="drawer-list-item">
          <v-list-item-icon>
            <v-icon>mdi-wrench</v-icon>
          </v-list-item-icon>
          <v-list-item-content>
            <v-list-item-title>Ajustes</v-list-item-title>
          </v-list-item-content>
        </v-list-item>
      </v-list>
    </v-navigation-drawer>

    <v-app-bar app v-if="this.$route.path != '/login'">
      <v-btn icon @click="toggleDrawer">
        <v-icon>mdi-menu</v-icon>
      </v-btn>
      <div class="d-flex align-center">
        <router-link to="/">
          <v-img 
          alt="Company Logo" 
          class="shrink" 
          max-height="32"
          max-width="32"
          contain 
          src="@/assets/aml_logo.png"
            transition="scale-transition" />
        </router-link>

    
      </div>
      <v-spacer></v-spacer>

      <!-- Close session -->
      <v-tooltip bottom>
        <template v-slot:activator="{ on }">
          <v-btn class="mt-1 elevation-1" v-on="on" @click="logout" rounded> <v-icon>mdi-logout</v-icon></v-btn>
        </template>
        <span>Cerrar Sesión</span>
      </v-tooltip>
    </v-app-bar>
    <v-main>
      <router-view />
    </v-main>

  </v-app>
</template>

<script>
import { mapActions } from 'vuex'
export default {
  name: 'App',

  data: () => ({
    drawer: false,
    mantenimientos: [],
    checklists: [],
  }),

  async created() {
    await this.createConnection()
    if(localStorage.getItem("user")){
      this.cargaInicial();
      this.setIsAdmin(JSON.parse(localStorage.getItem("user")).role_name == 'admin')
    }    
  },

  methods: {
    ...mapActions( 'api',['logout']),
    ...mapActions( 'nodered',['createConnection']),
    ...mapActions(['cargaInicial','getTratamientoActual','setIsAdmin']),
    toggleDrawer() {
      this.drawer = !this.drawer;
    },
    async methodGetAllInfo() {
      this.getAllData();
    },


  },

};
</script>

<style scoped>
.logo-drawer {
  padding-left: 15px;
  padding-right: 15px;
  padding-top: 15px;
  padding-bottom: 15px;
}

.drawer-list-item {
  margin-bottom: 5px;
}

.logo-drawer {
  padding: 15px;
}

/* Ajustar el tamaño del logo en la barra de la aplicación */
.v-img.shrink {
  max-width: 120px;
  max-height: 40px;
}
</style>